(ns net.kestec.mhda-pilgrimage.admin.applications.application-detail-actions
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Paper" :default Paper]
    ["@mui/material/Table" :default Table]
    ["@mui/material/Button" :default Button]
    ["@mui/material/TableBody" :default TableBody]
    ["@mui/material/TableRow" :default TableRow]
    ["@mui/material/TableCell" :default TableCell]

    ["@mui/icons-material/Delete" :default DeleteIcon]
    ["@mui/icons-material/CheckCircleOutline" :default CheckIcon]
    ["@mui/icons-material/HighlightOff" :default UnCheckIcon]

    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-small grid-medium grid-full text-field text-field-multi select radio-yes-no]]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.route :as-alias route]
    [net.kestec.mhda-pilgrimage.admin.applications.applications-events :as-alias admin-applications-events]
    [net.kestec.mhda-pilgrimage.admin.applications.application-events :as-alias admin-application-events]
    [net.kestec.mhda-pilgrimage.admin.applications.application-detail-document-list :as application-documents]
    [net.kestec.mhda-pilgrimage.admin.popup.application-delete-popup :refer [application-delete-popup]]
    [net.kestec.mhda-pilgrimage.public.page-structure :refer [base-page]]


    [day8.re-frame.http-fx]
    [reagent.core :as r]
    [re-frame.core :as rf]
    ))



(defn action-part []
  (let [groups @(rf/subscribe [::db/get ::db/me :enriched-session :groups])
        application-id @(rf/subscribe [::db/get ::route/route :path-params :application-id])
        application @(rf/subscribe [::db/get ::db/admin-selected-application])]
    [:<>
     ;[:pre "ID:"(:id application)]
     [application-delete-popup]
     [grid-full
      (when (or (some #(= % "/admin_MED") groups)
                (some #(= % "/pilgrimage_admin") groups)
                )
        [:> Button
         {:sx        {:float "" :backgroundColor "darkred"}
          :variant   "contained"
          :startIcon (r/as-element [:> DeleteIcon])
          :onClick   #(rf/dispatch [::admin-application-events/show-delete-popup application-id])
          }
         "Löschen"])

      (when (or (some #(= % "/admin_MED") groups)
                (some #(= % "/pilgrimage_admin") groups)
                )
        [:> Button
         {:style     {:float "right" :backgroundColor (if (:med_checked application) "darkgreen" "darkred")}
          :variant   "contained"
          :startIcon (r/as-element (if (:med_checked application) [:> CheckIcon] [:> UnCheckIcon]))
          :onClick   (fn []
                       (rf/dispatch [::admin-application-events/update-application application-id {:med_checked (if (:med_checked application) false true)}])
                       (rf/dispatch [::admin-applications-events/load-applications])
                       )
          }
         (if (:med_checked application) "Med und Pflegedaten OK" "Med und Pflegedaten nicht geprüft")])


      [:> Button
       {:style     {:float "right" :marginRight "10px" :backgroundColor (if (:application_checked application) "darkgreen" "darkred")}
        :variant   "contained"
        :startIcon (r/as-element (if (:application_checked application) [:> CheckIcon] [:> UnCheckIcon]))
        :onClick   (fn []
                     (rf/dispatch [::admin-application-events/update-application application-id {:application_checked (if (:application_checked application) false true)}])
                     (rf/dispatch [::admin-applications-events/load-applications])
                     )
        }
       (if (:application_checked application) "Daten geprüft" "Daten NICHT geprüft")]
      ]

     [application-documents/document-list application]
     ]

    ))
